import { GetCatalogProductViewQuery } from '@notino/shared/definitions/types';

export const getProductFullName = (
  product: GetCatalogProductViewQuery['productDetailByCatalogMasterId']
): string =>
  [product?.brand?.name, product?.collection, product?.subName]
    .filter(Boolean)
    .join(' ');
